export const MENUHETHONG_SET_LIST_DATA = 'MENUHETHONG_SET_LIST_DATA';
export const MENUHETHONG_SET_LIST_META = 'MENUHETHONG_SET_LIST_META';